import {Text} from '@rdcomponents/text/text';
import {Card, Skeleton} from 'antd';

import {FormattedNumber} from '../../../../../../provider/locale/formatted-number';
import {RatingDynamicsCompaniesStatsDataType} from '../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

import * as styles from './rating-history-average-rating-card.scss';

type PropsType =
    | {
          ratingData: Exclude<
              RatingDynamicsCompaniesStatsDataType['ratingsAverage']['overallAverage'],
              null | undefined
          >;
          loading?: never;
      }
    | {
          loading: true;
          ratingData?: never;
      };

export function RatingHistoryAverageOverallRatingCard(props: PropsType): JSX.Element {
    const {ratingData} = props;

    return (
        <Card>
            <div className={styles.RatingHistoryAverageRating}>
                <Text block secondary small stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__OVERALL_AVERAGE_RATING" />

                {ratingData ? (
                    <Text block bolder className={styles.RatingHistoryAverageRating_value}>
                        <FormattedNumber options={{maximumFractionDigits: 1}} value={ratingData.target} />
                    </Text>
                ) : (
                    <Skeleton.Input active size="large" />
                )}
            </div>
        </Card>
    );
}
